import { useEffect, useState } from 'react';

import { isMobile } from '@nocowanie/core/helpers';

export const useIsMobile = () => {
    const [isMobileValue, setIsMobileValue] = useState(false);

    useEffect(() => {
        setIsMobileValue(isMobile());
    }, []);

    return isMobileValue;
};
